import { render, staticRenderFns } from "./dataFilter.vue?vue&type=template&id=39a2706f&scoped=true&"
import script from "./dataFilter.vue?vue&type=script&lang=js&"
export * from "./dataFilter.vue?vue&type=script&lang=js&"
import style0 from "./dataFilter.vue?vue&type=style&index=0&id=39a2706f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a2706f",
  null
  
)

export default component.exports